import Script from "next/script";

import MainTemplate from "@/components/Templates/MainTemplate";

import BootCampLandingPage from "@/containers/BootCampPages/BootCampLandingPage";

import { renderMetaData } from "@/utils";

import * as actions from "@/redux/BootCampReducer";
import { wrapper } from "@/redux/Store";

interface BootCampProps {
  data: any;
}

const BootCamp: React.FC<BootCampProps> = ({ data }) => {
  const meta = {
    title: data?.meta.title || data?.title,
    description: data?.meta.description || data?.description,
    pageTitle: data?.meta.pageTitle,
    pageDescription: data?.meta.pageDescription,
    thumbnail: data?.meta?.image,
  };

  const metaTags = renderMetaData(meta);

  return (
    <>
      {metaTags}
      <Script defer={true} src="https://tally.so/widgets/embed.js" />
      <div className="plans/[bootcamp-type] bbbbbbbbbbbbbbbbbbbbbbbbbbbbb"></div>
      <main id="bootcamp-page">
        <MainTemplate hideRibbon>
          <BootCampLandingPage />
        </MainTemplate>
      </main>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {
      let bootcampType =
        typeof query?.bootcampType === "string"
          ? query?.bootcampType
          : query?.bootcampType?.[0] || "";

      const bootCampData = await store.dispatch(
        actions.getBootCampPageData({
          bootcampType: "general",
          pageSlug: bootcampType,
        })
      );

      if (bootCampData?.payload) {
        return {
          props: {
            data: bootCampData?.payload || null,
          },
        };
      } else {
        // return {
        //   notFound: true,
        // };
        return {
          redirect: {
            destination: '/', 
            permanent: true      },
        }
      }
    }
);

export default BootCamp;
